import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import TransactionStatusNode from "./TransactionStatusNode";

export default function TransactionsCardList({
  rows,
  showPaymentAccount = false,
  renderAmount,
  renderExtra,
  onCompleteRemainingPayment,
  onViewPayments,
  emptyState,
}) {
  if (!rows || rows.length === 0) return emptyState || null;

  return (
    <Stack spacing={2} sx={{ px: { xs: 2, sm: 3 }, py: { xs: 2, sm: 3 } }}>
      {rows.map((row) => (
        <Card key={row._id} sx={{ boxShadow: 1, borderRadius: 2 }}>
          <CardContent>
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="flex-start"
              sx={{
                "@media (max-width:500px)": {
                  flexDirection: "column",
                },
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: 92,
                  height: 68,
                  flex: "0 0 auto",
                  overflow: "hidden",
                  borderRadius: 1.5,
                  bgcolor: "background.default",
                  "@media (max-width:500px)": {
                    width: "100%",
                    height: 140,
                  },
                }}
              >
                <Box
                  component="img"
                  src={row.imgUrl}
                  alt="Asset"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
                {(row.purpose === "REFERRAL_REWORD" ||
                  row.purpose === "FOUNDER_CIRCLE_REWORD") && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 9,
                      left: -14,
                      width: 70,
                      bgcolor: "#FF382D",
                      color: "#fff",
                      fontSize: "7px",
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                      textAlign: "center",
                      lineHeight: 1.2,
                      py: "2px",
                      px: "10px",
                      boxSizing: "border-box",
                      transform: "rotate(-45deg)",
                      zIndex: 1,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.purpose === "REFERRAL_REWORD" ? "REWORD" : "F.C REWORD"}
                  </Box>
                )}
              </Box>
              <Stack spacing={0.25} sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={row.propertyName}
                >
                  {row.propertyName}
                </Typography>
                <Typography
                  variant="body3"
                  sx={{
                    color: "text.secondary",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={row.transactionId || "-"}
                >
                  Ref: {row.transactionId || "-"}
                </Typography>
                <Box
                  sx={{
                    mt: 0.75,
                    "@media (max-width:450px)": {
                      width: "100%",
                    },
                  }}
                >
                  <TransactionStatusNode
                    row={row}
                    fullWidthAction={true}
                    onCompleteRemainingPayment={onCompleteRemainingPayment}
                  />
                </Box>
              </Stack>
            </Stack>

            <Divider sx={{ my: 1.5 }} />

            <Stack spacing={1}>
              <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Typography variant="label">Committed</Typography>
                <Typography variant="body3" sx={{ textAlign: "right" }}>
                  {row.created_at || "-"}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Typography variant="label">Last Txn</Typography>
                <Typography variant="body3" sx={{ textAlign: "right" }}>
                  {row.lastPaymentDate || "-"}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Typography variant="label">Tokens</Typography>
                <Typography variant="body3" sx={{ textAlign: "right" }}>
                  {row.noOfFracs ?? "-"} {row.tokenName || "FRAX"}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Typography variant="label">Amount</Typography>
                <Box sx={{ textAlign: "right" }}>{renderAmount?.(row)}</Box>
              </Stack>
              {showPaymentAccount && (
                <Stack direction="row" justifyContent="space-between" spacing={2}>
                  <Typography variant="label">Payment Account</Typography>
                  <Typography variant="body3" sx={{ textAlign: "right" }}>
                    {row.entityType === "HUF"
                      ? "HUF"
                      : row.entityType === "TRUST"
                        ? "TRUST"
                        : row.entityType === "FAMILYMEMBER"
                          ? (row?.username
                            ? `${row?.username}(${row?.relation})`
                            : "Family")
                          : "Personal"}
                  </Typography>
                </Stack>
              )}
              {renderExtra ? renderExtra(row) : null}
            </Stack>

            <Stack spacing={1} mt={2}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => onViewPayments?.(row)}
              >
                View Payments
              </Button>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}

